import { CommonServices } from "@/services/CommonServices";
import { apiurl} from '@/config';
import * as OM from '@/model';
import * as VM from '@/viewmodel';

class _UploadServices {

    UploadFile(vm: VM.UploadFileVm){
        return CommonServices.uploadFileToUrl<OM.Attachment>(apiurl + "api/Upload/UploadFile", vm)
    }

    UploadComment(vm: VM.AddCommentVm){
        return CommonServices.uploadFileToUrl<OM.Comment>(apiurl + "api/Upload/UploadComment", vm)
    }

    ImportFromExcel(vm: VM.UploadFileVm){
        return CommonServices.uploadFileToUrl<VM.QrConfigExcelImportResultVm[]>(apiurl + "api/QrConfig/ImportFromExcel", vm)
    }

    PreviewColumns(vm: VM.ExcelPreviewRequestVm){
        return CommonServices.uploadFileToUrl<VM.ExcelColumnPreviewVm[]>(apiurl + "api/ExcelQrMapping/PreviewColumns", vm)
    }

    GetQrConfigFields(){
        return CommonServices.defaultGet<string[]>(apiurl + "api/ExcelQrMapping/GetQrConfigFields")
    }

    ImportFromExcelWithMapping(vm: VM.UploadFileVm){
        return CommonServices.uploadFileToUrl<VM.QrConfigExcelImportResultVm[]>(apiurl + "api/QrConfig/ImportFromExcelWithMapping", vm)
    }

    ImportFromExcelWithMappingSuperAdmin(vm: VM.UploadFileVm){
        return CommonServices.uploadFileToUrl<VM.QrConfigExcelImportResultVm[]>(apiurl + "api/QrConfig/ImportFromExcelWithMappingSuperAdmin", vm)
    }


}

export let UploadServices = new _UploadServices();
